import React, { useContext, useEffect, useState } from "react";
import MissionDocumentType from "./MissionDocumentType";
import MissionPastDocument from "./MissionPastDocument";
import { MissionContext } from "../contexts/MissionTasksContext";
import { useSelector } from "react-redux";
import { USER_ROLES } from "constants";
import { Mission_Document_Category, Mission_Document_Sub_Category, Mission_Document_type } from "modules/pvs_activities/constants";
import Index from "pages/backend/metadata/expert-tool-documents/Index";

const MissionDocument = ({ missionID, userID }) => {

  const MissionDataContext = useContext(MissionContext);
  const [baselineDocuments, setBaselineDocuments] = useState([]);
  const [correspondenceDocuments, setCorrespondenceDocuments] = useState([]);
  const [otherDocuments, setOtherDocuments] = useState([]);
  const authData = useSelector(s => s.auth.data);
  useEffect(() => {
    const d = MissionDataContext.missionDocuments.filter(x => parseInt(x.type_id) === Mission_Document_type.baseline_document);
    const d3 = MissionDataContext.missionDocuments.filter(x => parseInt(x.type_id) === Mission_Document_type.correspondence_document);
    const d4 = MissionDataContext.missionDocuments.filter(x => parseInt(x.type_id) === Mission_Document_type.other_document);
    setBaselineDocuments(d);
    setCorrespondenceDocuments(d3);
    setOtherDocuments(d4);
  }, [MissionDataContext.missionDocuments]);
  return (
    <>
      <MissionDocumentType
        documents={baselineDocuments}
        typeName="Baseline Documents"
        documentTypeID={Mission_Document_type.baseline_document}
        // documentCatagory={Mission_Document_Category.baseline_document}
        // documentSubCatagory={Mission_Document_Sub_Category.baseline_document}
        missionID={missionID}
        userID={userID} />
     

      <MissionDocumentType
        documents={correspondenceDocuments}
        typeName="Mission Correspondence"
        documentTypeID={Mission_Document_type.correspondence_document}
        // documentCatagory={Mission_Document_Category.correspondence_document}
        // documentSubCatagory={Mission_Document_Sub_Category.correspondence_document}
        missionID={missionID}
        userID={userID}
      />
      
      <MissionPastDocument typeName="Past Reports" />
      {
        USER_ROLES.business_admin.includes(parseInt(authData?.role_id)) &&
        <MissionDocumentType
          documents={otherDocuments}
          typeName="Other Documents"
          documentTypeID={Mission_Document_type.other_document}
          missionID={missionID}
          userID={userID}
        />
      }

{
        !USER_ROLES.delegate.includes(parseInt(authData?.role_id)) &&
        <Index showOther={false} />

      }
    </>
  );
};

MissionDocument.defaultProps = {
  missionID: "",
  userID: ""
};

export default MissionDocument;
